import React, { memo } from 'react';

import { ILevelRiskProps } from './level-risk.model';

import { Agressivo, Conservador, Arrojado, Moderado, RiskName } from './styles';

export const UiLevelRisk = memo<ILevelRiskProps>(({ levelRisk }: ILevelRiskProps) => {
  if (!levelRisk || typeof levelRisk !== 'number') return null;

  if (levelRisk <= 2) {
    return (
      <Conservador>
        <RiskName>CONSERVADOR</RiskName>
      </Conservador>
    );
  }

  if (levelRisk > 2 && levelRisk <= 4) {
    return (
      <Moderado>
        <RiskName>MODERADO</RiskName>
      </Moderado>
    );
  }

  if (levelRisk > 4 && levelRisk <= 8) {
    return (
      <Arrojado>
        <RiskName>ARROJADO</RiskName>
      </Arrojado>
    );
  }

  if (levelRisk > 8) {
    return (
      <Agressivo>
        <RiskName>AGRESSIVO</RiskName>
      </Agressivo>
    );
  }
});
